import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import config from "@/lib/config";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";
class PlaybackEngine extends RESTDataSource {
  constructor(options) {
    super(options);
    _defineProperty(this, "baseURL", config.playback.url);
    _defineProperty(this, "merchantId", config.playback.merchantId);
    this.context = options;
  }
  setPlaybackSessionId(sessionId) {
    if (this.context.req) {
      this.context.req.playbackSessionId = sessionId;
    }
  }
  async open(mediaId, sessionId) {
    var _this$context;
    const params = {
      user_id: (_this$context = this.context) === null || _this$context === void 0 || (_this$context = _this$context.req) === null || _this$context === void 0 || (_this$context = _this$context.userToken) === null || _this$context === void 0 ? void 0 : _this$context.id
    };
    this.setPlaybackSessionId(sessionId);
    return this.get(`/session_proxy/open/v1/merchants/${this.merchantId}/medias/${mediaId}`, {
      params
    });
  }
  async check(sessionId) {
    this.setPlaybackSessionId(sessionId);
    return this.post("/session/check", {});
  }
  async close(sessionId) {
    this.setPlaybackSessionId(sessionId);
    return this.post(`/session_proxy/close`, {});
  }
  willSendRequest(_path, request) {
    var _this$context$req, _this$context2;
    // UAをプロキシする
    request.headers["User-Agent"] = `${this.context.req.deviceInfo.ua} spooxweb`;
    if ((_this$context$req = this.context.req) !== null && _this$context$req !== void 0 && _this$context$req.userToken) {
      const {
        id,
        accessToken
      } = this.context.req.userToken;
      request.headers["X-User-Id"] = id;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    if ((_this$context2 = this.context) !== null && _this$context2 !== void 0 && (_this$context2 = _this$context2.req) !== null && _this$context2 !== void 0 && _this$context2.playbackSessionId) {
      var _this$context3;
      request.headers["X-Playback-Session-Id"] = (_this$context3 = this.context) === null || _this$context3 === void 0 || (_this$context3 = _this$context3.req) === null || _this$context3 === void 0 ? void 0 : _this$context3.playbackSessionId;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Playback-Request-Id"] = requestId;
    const userId = request.headers["X-User-Id"];
    console.log(`[${requestId}][Playback][REQUEST INFO] Method: ${request.method}, Path: ${request.path}, UserId: ${userId}`);
  }
  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Playback-Request-Id"];
    console.log(`[${requestId}][Playback][RESPONSE INFO] Status: ${response.status}`);
    return super.didReceiveResponse(response, request);
  }
}
export default PlaybackEngine;